module.exports = __webpack_public_path__ + "media/images/icon-keyboard-arrow-down-dc92507da43af045f3c9c1bc100c90f6.svg";